import Transformer from '../transformer'

export default class SinisterTransformer extends Transformer {

  static fetch(budgetReport) {

    return {
      sinister: budgetReport.sinister,
      sinister_id: budgetReport.sinister_id,
      sinisterScope: {
        expectedScope: budgetReport.scope,
        realScope: budgetReport.real_worked_days
      },
      sinisterMasters: {
        expectedMasters: budgetReport.master_workers,
        realMasters: +budgetReport.average_master_workers
      },
      sinisterOfficials: {
        expectedOfficials: budgetReport.official_workers,
        realOfficials: +budgetReport.average_official_workers,
      },
      sinisterAssistants: {
        expectedAssistant: budgetReport.assistant_workers,
        realAssistant: +budgetReport.average_assistant_workers
      },
      sinisterFlagers: {
        expectedFlag: budgetReport.flag_workers,
        realFlag: +budgetReport.average_flag_workers
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/transformers/budgetReport/budgetTransformer.js